<template>
  <v-select
    filled
    :hide-details="!isRequired"
    :label="title"
    :items="fields"
    item-text="name"
    item-value="name"
    :rules="rules"
    :value="value"
    @input="onChange"
    :disabled="disabled"
    clearable
  ></v-select>
</template>

<script>
import ui from "../../../services/ui";
import constants from "../../../helpers/constants";
import helpers from "../../../helpers/helpers";

export default {
  name: "FieldPicker",

  props: [
    "title",
    "isRequired",
    "value",
    "table",
    "containers",
    "component",
    "source",
    "disabled",
  ],

  watch: {
    table() {
      this.refresh();
    },
    source() {
      this.refresh();
    },
  },

  data() {
    return {
      fields: [],
      rules: this.isRequired ? [ui.requiredRule] : [],
    };
  },

  mounted() {
    this.refresh();
  },

  methods: {
    async refresh() {
      if (!this.source || this.source == constants.FIELD_SOURCE_COMPONENT) {
        if (this.table) {
          this.fields = await helpers.getTableFields(this.table);
          return;
        } else if (this.component) {
          this.fields = helpers.getComponentFields(this.component);
          return;
        }
      } else if (this.source == constants.FIELD_SOURCE_PAGE) {
        if (this.containers) {
          this.fields = helpers.getPageFields(this.containers);
          return;
        }
      } else if (this.source == constants.FIELD_SOURCE_COMPONENT) {
        if (this.component) {
          this.fields = helpers.getComponentFields(this.component);
          return;
        }
      }

      this.fields = [];
    },
    getDataType(name) {
      for (let i = 0; i < this.fields.length; i++) {
        const f = this.fields[i];
        if (f.name == name) {
          if (f.dataType) {
            return f.dataType;
          } else if (f.type) {
            var lType = f.type.toLowerCase();

            if (lType.search("number") > -1) {
              return constants.DATA_TYPE_NUMBER;
            } else if (lType.search("check") > -1) {
              return constants.DATA_TYPE_BOOL;
            } else if (lType.search("date") > -1) {
              return constants.DATA_TYPE_DATE;
            } else {
              return constants.DATA_TYPE_TEXT;
            }
          } else {
            return constants.DATA_TYPE_TEXT;
          }
        }
      }

      return constants.DATA_TYPE_TEXT;
    },
    onChange(e) {
      if (e) {
        this.$emit("input", e);
        this.$emit("type-change", this.getDataType(e));
      } else {
        this.$emit("input", null);
        this.$emit("type-change", null);
      }
    },
  },
};
</script>
